class ReportWidget extends BaseWidget<ReportWidgetResultVM, ReportConfig> {
    override widgetType = WidgetType.Report;

    private searchBoxHeight = 31;

    fakeColumnName = "fake";
    static readonly tagLinkDrilldown = "#icondrilldown#";
    static readonly linkDrilldown = `<a class='drilldowrow' title='Click to drilldown'><span class='material-icons' style='color: #337ab7;font-size:12px;'>more_horiz</span></a>`;

    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);
    }

    setConfig(config) {
        this.itemConfig = new ReportConfig(config);
    }

    setResult(result) {
        this.result = new ReportWidgetResultVM(result);

        //Update the fields/metrics because their names may have changed, this is when using date variables in the name. [YEAR], [MONTH]...
        if (result.itemConfig) {
            (this.itemConfig as ReportConfig).updateFieldsGroupsMetrics(result.itemConfig);
        }
    }

    setup() {
        
        let self = this;
        let context = this.$reportContent;

        if (!this.result.gridContainer) {
            this.result.gridContainer = $('.gridContainer', context);
        }
        
        if (this.result.gridContainer.length === 0)
            return;

        if (!this.result.baseColumns) {
            this.result.baseColumns = this.result.columns.map((c) => ({ ...c }));
        }
        
        if (!workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting) {
            let offSet = this.result.gridContainer.offset();
            let windowHeight = $(window).height();
            //gridContainer.css("overflow", "auto");
            ////-40 so we can avoid unecessary vertical scrollbars.
            let calculatedHeight = windowHeight - offSet.top - 5;


            let widget = this.result.gridContainer.closest(".widgetContainer");
            if (widget.length > 0) {
                if (this.result.reportType === ReportTypeEnum.Pivot) {
                    if (this.itemConfig.enableSearchBox()) {
                        this.result.gridContainer.css("height", `calc(100% - ${PivotWidget.searchBoxHeight}px)`);
                    }
                }
            }
            else {
                if (this.result.reportType === ReportTypeEnum.Pivot) {
                    if (this.itemConfig.enableSearchBox()) {
                        //31px is the total height of the search box
                        calculatedHeight -= PivotWidget.searchBoxHeight;
                    }
                }
            }
        }
        
        this.result.gridContainer.attr("glreport", this.itemConfig.glReport());
        this.result.gridContainer.attr("subtotalsposition", this.itemConfig.subtotalsPosition());//Used to show/hide the summaries when grouping is collapsed
        this.result.gridContainer.attr("enablerowselection", this.itemConfig.enableRowSelection());
        
        if (!workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting) {
            //remove the json content, it is not necessary anymore
            this.result.gridContainer.data("result", "");
            this.result.gridContainer.attr("data-result", null);
        }

        this.result.totalItems = [];
        this.result.groupItems = [];

        this.result.columns = this.setupGridColumns();

        let countColumns = this.result.columns.filter(x => !x.isGrouping && !x.isMetric && x.visible);
        if (countColumns.length > 0 && this.itemConfig.totalsPosition() !== TotalsPositionEnum.None) {
            this.result.totalItems.push({
                column: countColumns[0].dataField,
                summaryType: 'count',
                displayFormat: `${ReportWidget.tagLinkDrilldown}${this.itemConfig.grandTotalText()}${(this.itemConfig.showReportRowCount() ? " ({0})" : "")}`
            });
        }

        if (this.result.result === null) {
            this.result.hasGrouping = false;
        }

        if (countColumns.length > 0 && this.itemConfig.subtotalsPosition() !== TotalsPositionEnum.None) {
            this.result.groupItems.push({
                showInColumn: countColumns[0].dataField,
                showInGroupFooter: this.itemConfig.subtotalsPosition() === TotalsPositionEnum.Bottom,
                summaryType: 'custom',
                alignByColumn: true,
                customizeText: function (e) {
                    let valueText = e.valueText;
                    if (valueText) {
                        valueText = valueText.replace(/<!--.*?-->/g, "");
                    }

                    return valueText;
                },
                name: "ForSubTotal",
            });
        }

        DevExpress.config({ defaultCurrency: this.result.currencyCode });

        if (this.result.reportType === ReportTypeEnum.Analysis) {
            this.result.collapseRows = [];
            this.result.gridColumns = this.result.columns.slice();
            if (this.result.numberFixedColumns > 0) {
                if (!this.result.gridContainer.hasClass("fixingColumns")) {
                    this.result.gridContainer.addClass("fixingColumns");
                }

                //**IRNG-1679
                this.result.gridColumns.push({
                    name: this.fakeColumnName, fixed: true, width: 1
                })

                if (countColumns.length > 0 && this.itemConfig.subtotalsPosition() !== TotalsPositionEnum.None) {
                    this.result.groupItems.push({
                        column: this.fakeColumnName,
                        alignByColumn: true
                    });
                }
                //***********
            }
            else {
                this.result.gridContainer.removeClass("fixingColumns");
            }

            //IRNG-1709
            let firstColumn = this.result.gridColumns.find(function (x) { return (x.groupIndex === undefined || x.groupIndex === null) && !x.isGrouping && !x.isMetric && x.visible; })
            if (firstColumn) {
                firstColumn.cellTemplate = function (container, options) {
                    if (self.itemConfig.enableRowSelection()) {
                        container.html(`${ReportWidget.linkDrilldown} ${options.text}`);

                        $("a.drilldowrow", container).click(function (e) {
                            self.reportRowClick(options.row, container, e);
                        });
                    }
                    else {
                        container.html(options.text);
                    }
                }
            }
            //---

            //IRNG-925
            this.result.resizeColumnsCfg = { inProgress: false, column: null, width: null, optionName: "" };

            this.result.gridContainer.on("mouseup", function () {
                if (self.result.resizeColumnsCfg.inProgress) {
                    let field = self.itemConfig.fields().find(function (x) { return x.queryName === self.result.resizeColumnsCfg.column.queryName; });
                    if (field) {
                        if (self.itemConfig.columnsWidthType() === ColumnsWidthTypeEnum.Automatic) {
                            //Has scrollbar
                            if (self.result.grid.getScrollable().scrollWidth() > self.result.grid.getScrollable().clientWidth()) {
                                self.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Pixel);
                            }
                            else {
                                self.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Percentage);
                                //let gridWidth = gridContainer.width() - visibleColumns.length - 1;
                                let borderWidth = 0;// result.grid.option("showColumnLines") ? 1 : 0;
                                self.result.resizeColumnsCfg.width = `${((self.result.resizeColumnsCfg.width + borderWidth) * 100 / self.result.gridContainer.width())}%`;
                                self.result.grid.columnOption(self.result.resizeColumnsCfg.column.dataField, "width", self.result.resizeColumnsCfg.width);
                            }
                        }

                        let width = self.result.resizeColumnsCfg.width;
                        if (width && typeof width === "string" && (width.includes("%") || width.includes("px"))) {
                            width = parseFloat(width.replace("%", "").replace("px", ""));
                        }

                        self.resizeColumns(self.result.resizeColumnsCfg.column);

                        field.width(width);

                        self.saveSettings(null);
                    }

                    self.result.resizeColumnsCfg.inProgress = false;
                }
            });
            //---

            if (workbook.workbookConfig.isExcelPrinting) {
                //Set column widths to fit content when exporting to Excel
                this.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Automatic);
                this.result.gridColumns.forEach(function (column) {
                    column.width = undefined;
                });
            }

            let gridConfig = this.getGridConfig();
            this.result.gridContainer.dxDataGrid(gridConfig);
            this.result.grid = this.result.gridContainer.dxDataGrid('instance');
        }
    }

    private getGridConfig() {
        let self: ReportWidget = this;
        let sortByGroupSummaryInfo = self.result.columns.filter(x => x.isMetric && x.sortIndex !== null).sort(x => x.sortIndex).map(x => {
            return { summaryItem: x.dataField, sortOrder: x.sortOrder };
        });

        let firstOnContentReady = true;

        return {
            focusedRowKey: undefined,
            focusedRowEnabled: false,

            allowColumnResizing: this.itemConfig.columnResizingMode() === ColumnResizingModeEnum.Widget ? true : !this.itemConfig.includeAllMetrics(),
            columnResizingMode: this.itemConfig.columnResizingMode() === ColumnResizingModeEnum.NextColumn ? "nextColumn" : "widget",
            columnAutoWidth: true,
            columnWidth: (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) && !this.isDashboardWidget ? "auto" : undefined,

            dataSource: this.result.result,
            showRowLines: true,
            rowAlternationEnabled: !this.itemConfig.glReport(),
            showBorders: !this.itemConfig.glReport(),
            showColumnLines: true,//!this.itemConfig.glReport(),
            columns: this.result.gridColumns,
            searchPanel: {
                visible: !workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting && this.itemConfig.enableSearchBox(),
                placeholder: 'Search...',
                searchVisibleColumnsOnly: true
            },
            height: workbook.workbookConfig.isExcelPrinting ? 200 : "100%", //undefined, //When sending the report as excel by email, we need to set the height for the scrolling.mode works
            width: workbook.workbookConfig.isExcelPrinting ? 200 : workbook.workbookConfig.isPrinting ? "auto" : "undefined", //When sending the report as excel by email, we need to set the width for the scrolling.mode works
            scrolling: {
                mode: workbook.workbookConfig.isPrinting ? 'standard' : 'virtual',
                useNative: false
            },
            paging: {
                enabled: false
            },
            sorting: {
                mode: 'none'
            },
            //columnChooser: {
            //    enabled: true,
            //    height: 400,
            //},
            grouping: {
                //allowCollapsing: !this.itemConfig.glReport(),
                allowCollapsing: true,
                //autoExpandAll: this.itemConfig.glReport() || (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) ? true : this.itemConfig.expandAllRows()
                autoExpandAll: (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) ? this.itemConfig.expandAllRowsPrinting() : this.itemConfig.expandAllRows()
            },
            summary: {
                totalItems: self.result.totalItems,
                groupItems: self.result.groupItems,
                calculateCustomSummary(options) {
                    //self.calculateCustomSummary.call(this, options);
                    self.calculateCustomSummary(options);
                }
            },
            sortByGroupSummaryInfo: sortByGroupSummaryInfo,
            onEditorPreparing: function (e) {
                if ((e as any).isMetric) {//IRNG-1846
                    e.editorName = "dxNumberBox";
                }
            },
            onContextMenuPreparing: function (e) {
                let hasGroupColumn = self.result.columns.filter(x => x.isGrouping).length > 0;
                e.items = [];

                if (e.target === "content" && hasGroupColumn) {
                    //if (!self.itemConfig.glReport()) {
                        e.items.push({
                            text: "Expand All",
                            onItemClick: function () {
                                e.component.expandAll();
                            }
                        });
                        e.items.push({
                            text: "Collapse All",
                            onItemClick: function () {
                                e.component.collapseAll();
                            }
                        });
                    //}
                }

                if (e.target === "header" && e.column) {
                    if (self.result.grid.option("allowColumnResizing")) {
                        e.items.push({
                            text: "Column Resizing Mode",
                            items: [
                                {
                                    text: "Next Column",
                                    selectable: true,
                                    onItemClick: function () {
                                        self.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Automatic);
                                        self.itemConfig.columnResizingMode(ColumnResizingModeEnum.NextColumn);
                                        self.saveSettings();
                                        self.result.grid.option("columnResizingMode", "nextColumn");
                                    },
                                    template: function (itemData) {
                                        return `<span style="display: block;" class="dx-menu-item-text ${(self.itemConfig.columnResizingMode() === ColumnResizingModeEnum.NextColumn ? `dx-menu-item-selected` : ``)}">${itemData.text}</span>${(itemData.items ? `<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>` : ``)}`
                                    }
                                },
                                {
                                    text: "Widget",
                                    selectable: true,
                                    onItemClick: function () {
                                        self.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Pixel);
                                        self.itemConfig.columnResizingMode(ColumnResizingModeEnum.Widget);
                                        self.resizeColumns(null);
                                        self.saveSettings();
                                        self.result.resizeColumnsCfg.inProgress = false;
                                        self.result.grid.option("columnResizingMode", "widget");
                                    },
                                    template: function (itemData) {
                                        return `<span style="display: block;" class="dx-menu-item-text ${(self.itemConfig.columnResizingMode() === ColumnResizingModeEnum.Widget ? `dx-menu-item-selected` : ``)}">${itemData.text}</span>${(itemData.items ? `<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>` : ``)}`
                                    }
                                }
                            ]
                        });
                    }

                    if (!self.itemConfig.includeAllMetrics()) {
                        let column = e.column as any;
                        let field = self.itemConfig.fields().find(function (x) { return x.queryName === column.queryName; });
                        if (field) {
                            e.items.push({
                                text: "Columns Width Type",
                                items: [
                                    {
                                        text: "Automatic",
                                        selectable: true,
                                        onItemClick: function () {
                                            self.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Automatic);
                                            self.resizeColumns(null);
                                            self.saveSettings();
                                            self.result.resizeColumnsCfg.inProgress = false;
                                            self.result.grid.repaint();
                                        },
                                        template: function (itemData) {
                                            return `<span style="display: block;" class="dx-menu-item-text ${(self.itemConfig.columnsWidthType() === ColumnsWidthTypeEnum.Automatic ? `dx-menu-item-selected` : ``)}">${itemData.text}</span>${(itemData.items ? `<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>` : ``)}`
                                        }
                                    },
                                    {
                                        text: "Percentage",
                                        selectable: true,
                                        onItemClick: function () {
                                            self.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Percentage);
                                            self.resizeColumns(null);
                                            self.saveSettings();
                                            self.result.resizeColumnsCfg.inProgress = false;
                                        },
                                        template: function (itemData) {
                                            return `<span style="display: block;" class="dx-menu-item-text ${(self.itemConfig.columnsWidthType() === ColumnsWidthTypeEnum.Percentage ? `dx-menu-item-selected` : ``)}">${itemData.text}</span>${(itemData.items ? `<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>` : ``)}`
                                        }
                                    },
                                    {
                                        text: "Pixels",
                                        selectable: true,
                                        onItemClick: function () {
                                            self.itemConfig.columnsWidthType(ColumnsWidthTypeEnum.Pixel);
                                            self.resizeColumns(null);
                                            self.saveSettings();
                                            self.result.resizeColumnsCfg.inProgress = false;
                                        },
                                        template: function (itemData) {
                                            return `<span style="display: block;" class="dx-menu-item-text ${(self.itemConfig.columnsWidthType() === ColumnsWidthTypeEnum.Pixel ? `dx-menu-item-selected` : ``)}">${itemData.text}</span>${(itemData.items ? `<span class="dx-menu-item-popout-container"><div class="dx-menu-item-popout"></div></span>` : ``)}`
                                        }
                                    }
                                ]
                            });
                        }
                    }
                }
            },
            //To apply white background
            onCellPrepared: function (e) {
                let column = e.column as any;
                e.cellElement.css({
                    "font-size": self.itemConfig.fontSize(),
                    "vertical-align": "middle"
                });

                if (e.rowType === "data") {
                    if (!column.isMetric) {
                        if (column.backgroundColor && column.backgroundColor !== "" && column.backgroundColor.toLowerCase() !== "#ffffff") {
                            e.cellElement.css("background-color", column.backgroundColor);
                        }

                        if (column.foreColor && column.foreColor !== "") {
                            e.cellElement.css("color", column.foreColor);
                        }
                    }
                }

                if (e.rowType == 'header' && !column.isGrouping) {
                    e.cellElement.on('click', function (evt) {
                        if (workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard &&
                            self.tabOrWidget !== workbook.workbookConfig.activeTabOrWidget()) {
                            return;
                        }

                        for (let field of self.itemConfig.fields()) {
                            field.orderIndex(null);
                        }

                        let focusedRowKey = null;
                        if (self.itemConfig.enableRowSelection()) {
                            focusedRowKey = e.component.option("focusedRowKey");
                        }

                        let orderFields = [];

                        let devSortOrder = !e.column.sortOrder ? "desc" : e.column.sortOrder === "desc" ? "asc" : null;
                        let sortOrder = devSortOrder === "desc" ? Order.DESC : devSortOrder === "asc" ? Order.ASC : Order.NONE;
                        e.component.beginUpdate();
                        e.component.clearSorting();
                        e.component.option("sortByGroupSummaryInfo", undefined);
                        if (devSortOrder !== null) {
                            let field = self.itemConfig.fields().find(x => x.queryName === column.queryName);
                            if (field) {
                                field.orderIndex(0);
                                field.order(sortOrder);
                            }

                            if (column.isMetric) {
                                e.component.option("sortByGroupSummaryInfo", [{
                                    summaryItem: column.dataField,
                                    sortOrder: devSortOrder
                                }]);
                            }

                            e.component.columnOption(column.dataField, "sortOrder", devSortOrder);

                            orderFields.push({ fieldName: column.queryName, order: sortOrder, orderIndex: 0 })
                        }
                        
                        e.component.endUpdate();

                        if (self.itemConfig.enableRowSelection()) {
                            setTimeout(() => {
                                e.component.beginUpdate();
                                e.component.option("focusedRowKey", undefined);
                                e.component.option("focusedRowKey", focusedRowKey);
                                e.component.endUpdate();
                            }, 300)
                        }

                        self.itemConfig.saveColumnOrdering(orderFields);
                    });
                }

                if ((e.rowType === "totalFooter" || e.rowType === "groupFooter" || e.rowType === "group") && column.isMetric) {
                    let elements = [e.cellElement];
                    e.cellElement.children().each(function () {
                        elements.push($(this));
                    });

                    const applyingFormattingRules = (e as any).summaryItems.length > 0 && column.hasFormattingRule;
                    if (applyingFormattingRules) {
                        let value = (e as any).summaryItems[0].value;
                        self.applyFormattingRuleCell(e.cellElement, { column: e.column, value: value, text: null, rowIndex: e.rowIndex }, e.rowType);
                    }
                    else {
                        elements.forEach(function (element) {
                            element.css("font-size", self.itemConfig.fontSize());

                            if (column.foreColor !== "#000000") {
                                if (!e.cellElement.hasClass("fr-row-fontColor-applied")) {
                                    element.css("color", column.foreColor);
                                }
                            }

                            if (column.backgroundColor && column.backgroundColor.toLowerCase() !== "#ffffff") {
                                if (!e.cellElement.hasClass("fr-row-backgroundColor-applied")) {
                                    element.css("backgroundColor", column.backgroundColor);
                                }
                            }
                        });
                    }

                    if ((e as any).summaryItems.length > 0) {
                        let value = (e as any).summaryItems[0].value;
                        //if (column.hasFormattingRule) {
                        //    applyFormattingRuleCell(result, e.cellElement, { column: e.column, value: value, text: null }, e.rowType);
                        //}

                        if (column.thresholdColor && column.thresholdValue !== undefined && column.thresholdValue !== null && value < column.thresholdValue) {

                            if (!e.cellElement.hasClass("fr-row-fontColor-applied") && !e.cellElement.hasClass("fr-fontColor-applied")) {
                                elements.forEach(function (element) {
                                    element.css("color", column.thresholdColor);
                                });
                            }
                        }
                    }
                }

                if (e.rowType === "totalFooter") {
                    let text = e.cellElement.html();
                    if (text && text.includes(ReportWidget.tagLinkDrilldown)) {
                        let lkDrillDown = ReportWidget.linkDrilldown.toString();
                        if (!self.itemConfig.enableRowSelection()) {
                            lkDrillDown = "";
                        }

                        text = (text as any).replaceAll(ReportWidget.tagLinkDrilldown, lkDrillDown);
                        e.cellElement.html(text);
                        $("a.drilldowrow", e.cellElement).off("click").on("click", function (ev) {
                            self.reportRowClick({}, e.cellElement, e);
                        });
                    }
                }

                if (self.itemConfig.glReport()) {
                    let backgroundColor = e.cellElement.css("background-color");
                    e.cellElement.css("border-left-color", backgroundColor).css("border-right-color", backgroundColor);
                }
            },
            onRowClick: function (e) {
                if (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting) {
                    return;
                }

                if (self.itemConfig.enableRowSelection()) {
                    e.event.stopPropagation();
                    e.component.beginUpdate();
                    e.component.option("focusedRowEnabled", true);
                    e.component.option("focusedRowKey", e.key);
                    e.component.endUpdate();
                }
                else {
                    self.reportRowClick(e, e.element, e.event);
                }
            },
            onInitialized: function (e) {
                if (self.result.gridColumns.filter(x => x.isGrouping).length > 0 && self.itemConfig.columnsWidthType() == ColumnsWidthTypeEnum.Pixel) {
                    try {
                        //Need to force width expand column
                        //https://intrep.atlassian.net/browse/IRNG-2072
                        //https://supportcenter.devexpress.com/ticket/details/t494138/dxdatagrid-it-is-impossible-to-set-width-for-the-expand-column-via-code
                        e.component.columnOption("command:expand", "width", 30);
                    } catch (ex) {

                    }
                }
            },
            onKeyDown: function (e) {
                self.showSearchBox(e.event);
            },
            onContentReady: function (e: DevExpress.ui.dxDataGrid.ContentReadyEvent) {
                setTimeout(function () {
                    let noDataElement = $(".dx-datagrid-nodata:not(.dx-hidden)", e.element);
                    if (noDataElement.length > 0) {
                        let introButton = $(`<div class="dx-datagrid-nodata"><intro-button params="introId: 'EmptyWorkbook'"></intro-button> <span>No data</span></div>`);
                        ko.applyBindings(null, introButton.get(0));
                        noDataElement.replaceWith(introButton);
                    }
                }, 100);

                if (self.itemConfig.totalsPosition() === TotalsPositionEnum.Top) {
                    $(".dx-datagrid-total-footer", e.element).css("border-bottom", "none").insertBefore($(".dx-datagrid-rowsview", e.element));
                }

                //Move the header grid row from the header table to the data table, so, the header is printed on each page
                if (workbook.workbookConfig.isPrinting && !workbook.workbookConfig.isExcelPrinting && !self.isDashboardWidget) {
                    var headerTable = $(".dx-datagrid-headers", e.element);
                    var headerRow = $("table tbody tr", headerTable);
                    headerRow.addClass("dx-header-row");
                    var tableBody = $(".dx-datagrid-rowsview table tbody", e.element);
                    var thead = $("<thead class='dx-datagrid-headers dx-datagrid-table' style='display: table-header-group; border-bottom: 2px solid #dddddd;'></thead>");
                    thead.prepend(headerRow.clone());
                    thead.insertBefore(tableBody);
                    headerTable.addClass("hidden");
                }

                if (self.itemConfig.glReport()) {
                    e.component.beginUpdate();
                    self.result.collapseRows.forEach(function (rowKey) {
                        e.component.collapseRow(rowKey);
                    });
                    self.result.collapseRows = [];
                    e.component.endUpdate();
                }

                self.addSeachBoxEvent();

                if (self.itemConfig.subtotalsPosition() === TotalsPositionEnum.Bottom) {
                    //const groupCount = self.result.gridColumns.filter(x => x.isGrouping).length;
                    //const footerTDSelectors = [".dx-row.dx-column-lines.dx-datagrid-group-footer > td", ".dx-datagrid-total-footer .dx-row.dx-footer-row > td"];
                    //const visColumns = e.component.getVisibleColumns().filter(c => c.groupIndex === undefined && !(c as any).isMetric && c.name !== self.fakeColumnName);
                    //const groupTotals = (e.component.option("summary.groupItems") as any).filter(g => g.showInGroupFooter);

                    //if (visColumns.length > 0 && groupTotals.length > 0) {
                    //    for (var c = 0; c < footerTDSelectors.length; c++) {
                    //        const footerTDSelector = footerTDSelectors[c];
                    //        e.element.find(`${footerTDSelector}[aria-colindex='${1 + groupCount}']`).attr("colspan", visColumns.length);
                    //        for (let i = 0; i < visColumns.length - 1; i++) {
                    //            e.element.find(`${footerTDSelector}[aria-colindex='${2 + groupCount + i}']`).css("display", "none");
                    //        }
                    //    }
                    //}
                }

                if (typeof irngCustom !== 'undefined' && irngCustom?.enableCustomization && irngCustom.onContentReadyReport) {
                    try {
                        irngCustom.onContentReadyReport(e, self.itemConfig.glReport(), self.result);
                    }
                    catch (err) {
                        console.log(`Error on irngCustom.onContentReadyReport: ${err.message}`);
                    }
                }

                if (firstOnContentReady) {
                    firstOnContentReady = false;
                }
            },
            onRowPrepared: function (e) {
                if (e.rowType !== "header") {
                    self.applyFormattingRuleRow(e.rowType, e.rowIndex, e.rowElement, (e as any).summaryCells);
                }

                if (self.itemConfig.glReport()) {

                    if (e.rowType === "group" || e.rowType === "groupFooter") {

                        e.rowElement.addClass("border-top-glreport");
                        if (e.rowType === "groupFooter") {
                            e.rowElement.addClass("border-bottom-glreport");
                            e.rowElement.prev().addClass("border-bottom-glreport");
                        }

                        if (e.rowType === "group" && e.groupIndex !== undefined) {
                            for (var i = 0; i < e.key.length; i++) {
                                let text = e.key[i];
                                if (e.key[i] && e.key[i].toString) {
                                    text = e.key[i].toString();
                                }
                                if ((typeof text === 'string' || text instanceof String) && text.includes("<!--collapse-->")) {
                                    self.result.collapseRows.push(e.key);
                                    e.rowElement.addClass("border-bottom-glreport");
                                    e.rowElement.addClass("gl-row-collapsed");
                                    break;
                                }
                            }
                        }
                    }
                }
            },
            onOptionChanged(e) {
                //IRNG-925
                if (e.fullName.startsWith("columns[") && e.fullName.includes("].width")) {
                    self.result.resizeColumnsCfg.inProgress = true;
                    self.result.resizeColumnsCfg.column = self.result.grid.option(e.fullName.replace("].width", "]"));
                    self.result.resizeColumnsCfg.width = e.value;
                    self.result.resizeColumnsCfg.optionName = e.fullName;
                }
                //---
            }
        } as any;
    }

    setupGridColumns() {
        let self = this;

        if (this.result.baseColumns) {
            this.result.columns = this.result.baseColumns.map((c) => ({ ...c }));
            this.result.formulasResolved = false;
        }

        let deubgLog = false;

        let gridColumns = [];
        let groupColumns = [];

        if (deubgLog) { console.log("result.columns"); console.log(this.result.columns); }

        for (var index = 0; index < this.result.columns.length; index++) {

            let column = this.result.columns[index];

            column.indexBase = column.index;
            column.encodeHtml = false; //Need to use because of html code in the data. Example: Links 
            column.cssClass = "column-text-style";
            column.headerCellTemplate = function (header, info) {
                header.closest("td").css("text-align", info.column.titleAlignment);
                //Need to use because of <br> in the column title, column.encodeHtml = false doesn't work for column title
                header.html(info.column.caption);
            }
            if (column.width === null)
                column.width = undefined; //Set width to undefined for column resize to work

            if (column.isMetric) {

                if (column.functionType === FunctionTypeEnum.Rank) {
                    column.showTotalValue = false;
                    column.showSubtotalValue = false;
                    column.groupingType = GroupingTypeEnum.SUM;
                }

                const isCustomMetric = column.groupingType === GroupingTypeEnum.WSUM ||
                    column.groupingType === GroupingTypeEnum.DSUM ||
                    column.groupingType === GroupingTypeEnum.WDSUM ||
                    (column.comparisonType >= ComparisonTypeEnum.Variation && column.groupingType !== GroupingTypeEnum.TSUM) ||
                    column.functionType === FunctionTypeEnum.AccumulatedAll ||
                    column.functionType === FunctionTypeEnum.PercentOfTotal ||
                    (column.functionType === FunctionTypeEnum.Accumulated && this.result.reportType === ReportTypeEnum.Analysis);
                let summaryType = isCustomMetric ?
                    'custom' :
                    column.groupingType === GroupingTypeEnum.MIN ?
                        'min' :
                        column.groupingType === GroupingTypeEnum.MAX ? 'max' : 'sum';

                if (column.groupingType === GroupingTypeEnum.TSUM) {
                    summaryType = 'max';
                }

                if (this.itemConfig.totalsPosition() !== TotalsPositionEnum.None && column.showTotalValue) {
                    self.result.totalItems.push({
                        name: column.dataField,
                        showInColumn: isCustomMetric ? column.dataField : null,
                        column: isCustomMetric ? null : column.dataField,
                        displayFormat: '{0}',
                        valueFormat: column.format,
                        summaryType: summaryType,
                    });
                }

                if (this.result.hasGrouping) {
                    if (this.itemConfig.subtotalsPosition() !== TotalsPositionEnum.None && column.showSubtotalValue) {
                        self.result.groupItems.push({
                            name: column.dataField,
                            showInColumn: isCustomMetric ? column.dataField : null,
                            column: isCustomMetric ? null : column.dataField,
                            summaryType: summaryType,
                            valueFormat: column.format,
                            displayFormat: '{0}',
                            showInGroupFooter: false,
                            alignByColumn: true,
                        });

                        if (this.itemConfig.subtotalsPosition() === TotalsPositionEnum.Bottom) {
                            self.result.groupItems.push({
                                name: column.dataField,
                                showInColumn: isCustomMetric ? column.dataField : null,
                                column: isCustomMetric ? null : column.dataField,
                                summaryType: summaryType,
                                valueFormat: column.format,
                                displayFormat: '{0}',
                                showInGroupFooter: true,
                                alignByColumn: true,
                            });
                        }
                    }
                }

                //WSUM and Comparison Variation Value and Percentage
                if (column.groupingType === GroupingTypeEnum.WSUM || column.comparisonType >= ComparisonTypeEnum.Variation) {
                    column.calculateCellValue = function (rowData) {
                        let calculateColumn = this;
                        let returnValue = 0;
                        if (calculateColumn.groupingType === GroupingTypeEnum.WSUM) {
                            if (calculateColumn.functionType === FunctionTypeEnum.PercentOfTotal && calculateColumn.comparisonType < ComparisonTypeEnum.Variation) {
                                const valueTop = rowData[calculateColumn.indexBase];
                                const valueBottom = rowData[calculateColumn.indexBottom];
                                const valueGrandTotal = rowData[calculateColumn.indexBase + 3];
                                returnValue = valueBottom === 0 || valueGrandTotal === 0 ? 0 : (valueTop / valueBottom) / valueGrandTotal;
                            }
                            else if (calculateColumn.comparisonType < ComparisonTypeEnum.Variation) {
                                let valueTop = rowData[calculateColumn.dataField];
                                let valueBottom = rowData[calculateColumn.indexBottom];
                                let value = valueBottom === 0 ? 0 : valueTop / valueBottom;
                                returnValue = value;
                            }
                            else {
                                let valueTop = rowData[calculateColumn.indexBase];
                                let valueTopComparison = rowData[calculateColumn.indexComparison];
                                let valueBottom = rowData[calculateColumn.indexBottom];
                                let valueBottomComparison = rowData[calculateColumn.indexBottomComparison];

                                let value = valueBottom === 0 ? 0 : valueTop / valueBottom;
                                let valueComparison = valueBottomComparison === 0 ? 0 : valueTopComparison / valueBottomComparison;

                                if (calculateColumn.functionType === FunctionTypeEnum.PercentOfTotal) {
                                    const valueGrandTotal = rowData[calculateColumn.indexBase + 3];
                                    const valueGrandTotalComparison = rowData[calculateColumn.indexComparison + 3];
                                    value = valueGrandTotal === 0 ? 0 : value / valueGrandTotal;
                                    valueComparison = valueGrandTotalComparison === 0 ? 0 : valueComparison / valueGrandTotalComparison;
                                }

                                let valueVariation = value - valueComparison;

                                if (calculateColumn.comparisonType === ComparisonTypeEnum.PercentageVariation) {
                                    valueVariation = valueComparison === 0 ? 0 : valueVariation / valueComparison;
                                }
                                returnValue = valueVariation;
                            }
                        }
                        else if (calculateColumn.comparisonType >= ComparisonTypeEnum.Variation) {
                            let value = rowData[calculateColumn.indexBase];
                            let valueComparison = rowData[calculateColumn.indexComparison];
                            value = value - valueComparison;
                            if (calculateColumn.comparisonType === ComparisonTypeEnum.PercentageVariation) {
                                value = valueComparison === 0 ? 0 : value / valueComparison;
                            }
                            returnValue = value;
                        }

                        //Need to round the value before the interface, so the search for numeric columns works
                        let precision = this.format.precision + (this.format.style === "percent" ? 2 : 0);
                        returnValue = Math.round(returnValue * (Math.pow(10, precision))) / (Math.pow(10, precision));
                        return returnValue;
                    }
                }
                else {
                    column.calculateCellValue = function (rowData) {
                        //Need to round the value before the interface, so the search for numeric columns works
                        let precision = this.format.precision + (this.format.style === "percent" ? 2 : 0);
                        let value = Math.round(rowData[this.dataField] * (Math.pow(10, precision))) / (Math.pow(10, precision));;
                        return value;
                    }
                }

                column.cellTemplate = function (container, options) {
                    let formattingRule = null;

                    if (options.column.hasFormattingRule) {
                        let formattingOptions = self.applyFormattingRuleCell(container, options, "data");
                        formattingRule = formattingOptions.formattingRule;
                    }
                    else {
                        let color = options.column.foreColor;
                        let backgroundColor = options.column.backgroundColor;

                        container.html(options.text);

                        if (color && !container.hasClass("fr-row-fontColor-applied")) {
                            container.css("color", color);
                        }

                        if (backgroundColor && backgroundColor.toLowerCase() !== "#ffffff") {
                            if (!container.hasClass("fr-row-backgroundColor-applied")) {
                                container.css("backgroundColor", backgroundColor);
                            }
                        }
                    }

                    if (options.column.hasBarChart) {
                        self.drawBarColumn(container, options, formattingRule);
                    }

                    if (options.column.thresholdColor && options.column.thresholdValue !== undefined && options.column.thresholdValue !== null && options.value < options.column.thresholdValue) {
                        if (!container.hasClass("fr-row-fontColor-applied") && !container.hasClass("fr-fontColor-applied")) {
                            container.css("color", options.column.thresholdColor);
                        }
                    }
                }

                if (column.hasBarChart) {

                    self.result.totalItems.push({
                        name: column.dataField + "_maxChart",
                        column: column.dataField,
                        cssClass: "hidden-total-summaries",
                        summaryType: 'max',
                        hasBarChart: true
                    });

                    self.result.totalItems.push({
                        name: column.dataField + "_minChart",
                        column: column.dataField,
                        cssClass: "hidden-total-summaries",
                        summaryType: 'min',
                        hasBarChart: true
                    });
                }

                //For Pivot
                column.area = "data";
                summaryType =
                    column.groupingType === GroupingTypeEnum.WSUM ||
                        column.comparisonType >= ComparisonTypeEnum.Variation /*|| column.functionType === 3*/ ?
                        'custom' :
                        column.groupingType === GroupingTypeEnum.MIN ?
                            'min' :
                            column.groupingType === GroupingTypeEnum.MAX ? 'max' : 'sum';
                if (column.groupingType === GroupingTypeEnum.TSUM) {
                    summaryType = 'max';
                }

                column.summaryType = summaryType;

                gridColumns.push(column);
                if (deubgLog) { console.log("Adding GridColumn Metric"); console.log(column); }
            }
            else {
                if (column.isGrouping || this.result.reportType === ReportTypeEnum.Pivot) {
                    column.visible = false;

                    if (this.result.reportType === ReportTypeEnum.Analysis) {
                        column.groupIndex = column.groupId;
                    }
                    else {
                        column.groupIndex = column.groupOrder;
                    }

                    let groupColumn = groupColumns.find(function (x) { return x.groupId === column.groupId && x.isGrouping === column.isGrouping; });
                    if (groupColumn === undefined || (this.itemConfig.reportType() === ReportTypeEnum.Pivot && this.itemConfig.pivotConfig.separateFields())) {
                        if (groupColumn && this.itemConfig.reportType() === ReportTypeEnum.Pivot && this.itemConfig.pivotConfig.separateFields()) {
                            groupColumn.columns.push(column);
                        }

                        groupColumn = {
                            isGrouping: column.isGrouping,
                            groupId: column.groupId,
                            columns: []
                        };
                        groupColumns.push(groupColumn);
                        groupColumns.sort((a, b) => a.groupId - b.groupId);
                    }

                    column.groupCellTemplate = function (element, options) {
                        element.html(options.displayValue);
                    };

                    groupColumn.columns.push(column);
                    if (deubgLog) { console.log("Adding Group"); console.log(column); console.log(groupColumn); }

                    //For Pivot                        
                    if (this.result.reportType === ReportTypeEnum.Pivot) {
                        column.area = column.isGrouping ? 'column' : 'row';
                    }
                }
                else {
                    column.groupIndex = undefined;
                    column.groupName = undefined;
                    gridColumns.push(column);

                    //Set the calculateCellValue this way for the search panel to work and to show the correct value
                    column.calculateCellValue = function (rowData) {
                        let value = this.defaultCalculateCellValue(rowData);
                        if (column.autoGrouping !== AutoGroupingEnum.None) {
                            return getAutoGroupingText(value, this.autoGrouping);
                        }

                        return value === null ? irSettings.nullText : value;
                    };
                    column.calculateSortValue = column.dataField;

                    if (deubgLog) { console.log("Adding GridColumn Field"); console.log(column); }
                }
            }

        }
        if (this.result.result) {
            groupColumns.forEach(function (groupColumn) {
                let gridGroupColumn = self.setupGroup(groupColumn.columns, groupColumn.groupId, groupColumn.isGrouping, deubgLog);
                if (deubgLog) { console.log("Adding Grouping Columns"); console.log(gridGroupColumn); }
                gridColumns.push(gridGroupColumn);
            });
        }

        if (!this.result.formulasResolved) {
            let re = /\[[a-zA-Z_0-9]*\]/g;
            for (var index = 0; index < this.result.columns.length; index++) {

                let column = this.result.columns[index];
                //DSUM or DWSUM
                if (column.groupingType === GroupingTypeEnum.DSUM || column.groupingType === GroupingTypeEnum.WDSUM) {
                    column.dependentColumns = [];
                    let variables;
                    let formula = column.formulaTop.replaceAll("=", "==");
                    while (variables = re.exec(column.formulaTop)) {
                        let variable = variables[0];
                        let queryName = variable.replace('[', '').replace(']', '');
                        let dColumn = this.result.columns.find(x => x.queryName === queryName);
                        formula = formula.replaceAll(variable, `[${dColumn.index}]`);
                        if (column.dependentColumns.find(x => x.queryName === queryName) === undefined) {
                            column.dependentColumns.push(dColumn);
                        }
                    }
                    column.formulaTop = formula;
                }
            }
            this.result.formulasResolved = true;
        }

        if (deubgLog) { console.log("Result"); console.log(this.result.result); }

        if (this.result.reportType === ReportTypeEnum.Pivot) {
            for (var index = 0; index < this.result.groupColumns.length; index++) {
                let column = this.result.groupColumns[index];
                this.result.columns.unshift({
                    caption: `G${column}`,
                    area: 'row',
                    groupName: `G${column}`,
                    allowExpandAll: true,
                    expanded: true,
                } as any);
            }
        }

        return gridColumns;
    }

    setupGroup(groupColumns, groupId, isGrouping, debugLog) {
        let self = this;

        let groupColumnIndex = self.result.result[0] ? self.result.result[0].length : 0;
        let caption = `Grouping-${groupId}-${(isGrouping ? 'C' : 'R')}`;
        if (groupColumns) {
            caption = "";
            for (let col of groupColumns) {
                if (caption != "") {
                    caption += irSettings.columnSeparatorForHtml;
                }
                caption += col.caption;

                if (self.itemConfig.reportType() === ReportTypeEnum.Pivot && self.itemConfig.pivotConfig.separateFields()) {
                    break;
                }
            }
            //groupColumns.forEach(function (col) {
                
            //});

            caption = replaceBasicHtmlContent((caption as any), false);
        }

        var groupingColumn = {
            groupColumns: groupColumns,
            encodeHtml: false,
            dataField: `${groupColumnIndex}`,
            index: groupColumnIndex,
            caption: caption,
            isGrouping: true,
            isMetric: false,
            groupIndex: self.result.reportType === ReportTypeEnum.Pivot ? undefined : groupId,
            groupId: groupId,
            groupCellTemplate: function (element, options) {
                let text = options.value + "";
                if (self.itemConfig.subtotalsPosition() === TotalsPositionEnum.Top && self.itemConfig.showReportRowCount()) {
                    let summary = options.summaryItems.find(function (x) { return x.name === "ForSubTotal"; });
                    //let countText = summary ? summary.value : "";
                    //text = `${text}${countText}`;
                    if (summary && summary.value) {
                        text = summary.value;
                    }
                }

                //IRNG-1709
                if (self.itemConfig.enableRowSelection()) {
                    element.html(`${ReportWidget.linkDrilldown} ${text}`);

                    $("a.drilldowrow", element).click(function (e) {
                        self.reportRowClick(options.row, element, e);
                    });
                }
                else {
                    element.html(text);
                }
                //---

                if (self.result.reportType === ReportTypeEnum.Analysis && groupColumns.length) {
                    element.css("text-align", groupColumns[0].alignment);
                }
            },

            //calculateCellValue and calculateDisplayValue are set this way for the search panel to work
            calculateCellValue: function (rowData) {
                return rowData[this.dataField].toString();
            },
            calculateDisplayValue: function (rowData) {
                return rowData[this.dataField];
            },
            //-----
            sortingMethod: function (value1, value2) {
                if (self.result.reportType === ReportTypeEnum.Pivot && groupColumns.filter((x) => { return !x.isMetric && x.sortOrder; }).length > 0) {
                    const sortColumn = groupColumns.find((x) => { return !x.isMetric && x.sortOrder; });
                    const index = groupColumns.indexOf(sortColumn)

                    let val1 = value1.value === undefined ? value1.values[index] : value1.value.values !== undefined ? value1.value.values[index] : value1.value;
                    let val2 = value2.value === undefined ? value2.values[index] : value2.value.values !== undefined ? value2.value.values[index] : value2.value;

                    if (val1 > val2)
                        return 1;
                    else if (val1 < val2)
                        return -1;
                }

                for (var j = 0; j < groupColumns.length; j++) {
                    let val1 = value1.value === undefined ? value1.values[j] : value1.value.values !== undefined ? value1.value.values[j] : value1.value;
                    let val2 = value2.value === undefined ? value2.values[j] : value2.value.values !== undefined ? value2.value.values[j] : value2.value;

                    if (val1 > val2)
                        return 1;
                    else if (val1 < val2)
                        return -1;
                }

                return 0;
            },
            area: isGrouping ? 'column' : 'row', //for Pivot
        };

        let groupValues = [];

        for (var i = 0; i < self.result.result.length; i++) {
            let resultRow = self.result.result[i];

            let groupValue = {
                text: "",
                values: [],
                toString: function () {
                    return this.text;
                },
                valueOf: function () {
                    return this.text;
                },

                totalTextSeparateFields: ""
            };

            /*
                Added comments tag only in Pivot when the field is invisible because it groups by text, 
                so we need to differentiate the values for it to create the rows;
                Example: two different ids (invisible field) with two identical names (visible field), Pivot needs to create two row for this
            */

            for (var j = 0; j < groupColumns.length; j++) {
                let column = groupColumns[j];
                let value = resultRow[parseInt(column.dataField)];

                groupValue.values.push(value);

                if (!column.visibleField && self.result.reportType !== ReportTypeEnum.Pivot) {
                    continue;
                }

                let text = groupValue.text;
                if (self.itemConfig.reportType() === ReportTypeEnum.Pivot && self.itemConfig.pivotConfig.separateFields()) {
                    text = groupValue.totalTextSeparateFields;
                }

                if (text.replace(/<!--.*-->/, "") !== "" && column.visibleField) {
                    text += `${(column.isGrouping ? self.itemConfig.getPivotColumnsSeparator() : irSettings.columnSeparatorForHtml)}`;
                }

                if (!column.visibleField) {
                    text += "<!--";
                }

                if (column.autoGrouping !== AutoGroupingEnum.None) {
                    let output = getAutoGroupingText(value, column.autoGrouping);
                    text += `${output}`;
                }
                else {
                    text += `${value === null ? irSettings.nullText : value !== undefined ? value : ""}`;
                }

                if (!column.visibleField) {
                    text += "-->";
                }

                if (self.itemConfig.reportType() === ReportTypeEnum.Pivot && self.itemConfig.pivotConfig.separateFields()) {
                    groupValue.totalTextSeparateFields = text;
                    if (j === 0) {
                        groupValue.text = text;
                    }
                }
                else {
                    groupValue.text = text;
                }
            }

            if (groupValues.filter(function (x) { return x.toString() === groupValue.toString(); }).length > 0) {
                groupValue = groupValues.find(function (x) { return x.toString() === groupValue.toString(); });
            }
            else {
                groupValues.push(groupValue);
            }

            resultRow[groupColumnIndex] = groupValue;
        }

        return groupingColumn;
    }

    drawBarColumn(containerDev, options, formattingRule) {
        let self = this;

        containerDev.css("font-size", self.itemConfig.fontSize());
        let minRowHeight = containerDev.height();
        containerDev.empty();
        containerDev.height(minRowHeight);

        let container = $("<div></div>");
        container.appendTo(containerDev)
        container.addClass("cell-bar");
        container.height(containerDev.height());

        let column = options.column as GridColumn;

        let padding = 8;
        let maxValue = options.component.getTotalSummaryValue(column.dataField + "_maxChart");
        let minValue = options.component.getTotalSummaryValue(column.dataField + "_minChart");
        let totalColumn = Math.max(Math.abs(maxValue), Math.abs(minValue));
        let hasNegativeValues = minValue < 0;
        let isNegative = options.value < 0;

        let widthBar = totalColumn == 0 ? 0 : Math.abs(options.value) / totalColumn * 100;

        let barColor = column.visualizationMode.color();
        let negativeColor = column.visualizationMode.negativeColor();
        let color = column.foreColor;

        if (column.visualizationMode.barChartText() === BarChartTextEnum.Percentage && column.format.style !== "percent") {
            let percentValue = options.value / totalColumn;
            if (formattingRule) {
                let formattingScale = FormattingRuleService.getFormattingRuleScale(formattingRule, percentValue, false);
                let colors = self.getFormattingScaleColor(formattingScale);
                if (colors.iconColor) {
                    barColor = colors.iconColor;
                    negativeColor = colors.iconColor;
                }
                if (colors.color) {
                    color = colors.color;
                }
            }

            options.text = DevExpress.localization.formatNumber(percentValue, { type: "percent", precision: column.format.precision });
        }
        else {
            if (formattingRule) {
                let formattingScale = FormattingRuleService.getFormattingRuleScale(formattingRule, options.value, column.format.style === "percent");
                let colors = self.getFormattingScaleColor(formattingScale);
                if (colors.iconColor) {
                    barColor = colors.iconColor;
                    negativeColor = colors.iconColor;
                }
                if (colors.color) {
                    color = colors.color;
                }
            }

            if (column.format.style !== "percent") {
                let divider = 1;
                let formatStr = "";
                if (Math.abs(options.value) >= 1000000000) {
                    formatStr = "B";
                    divider = 1000000000;
                }
                else if (Math.abs(options.value) >= 1000000) {
                    formatStr = "M";
                    divider = 1000000;
                }
                else if (Math.abs(options.value) >= 1000) {
                    formatStr = "K";
                    divider = 1000;
                }

                options.value = options.value / divider;

                var dx = DevExpress as any;
                if (column.format.style && column.format.style !== "currency") {
                    options.text = `${dx.formatHelper.format(options.value, { style: "decimal", precision: column.format.precision, currencySign: column.format.currencySign })}`;
                }
                else {
                    options.text = `${dx.formatHelper.format(options.value, { style: `currency`, currency: self.result.currencyCode, currencyDisplay: `narrowSymbol`, precision: column.format.precision, currencySign: column.format.currencySign })}`;
                }

                if (options.text.includes(")"))
                    options.text = options.text.replace(")", formatStr + ")");
                else
                    options.text += formatStr;
            }
        }

        if (!formattingRule && column.thresholdValue !== undefined && column.thresholdValue !== null && options.value < column.thresholdValue) {
            color = options.column.thresholdColor;
        }

        let span = null;
        let spanWidth = 0;
        if (column.visualizationMode.barChartText() !== BarChartTextEnum.None) {
            span = $(`<span title="${options.text}">${options.text}</span>`).css("color", color).addClass("report-bar-span").appendTo(container);
            if (column.visualizationMode.barChartTextPosition() === BarChartTextPositionEnum.End) {
                if (hasNegativeValues && !isNegative) {
                    spanWidth = span.width() + padding;
                }
                else {
                    spanWidth = span.width() + (padding * 2);
                }
            }
        }

        if (hasNegativeValues) {
            let halfNegativeBar = $('<div>').appendTo(container).addClass("report-bar-half-negative").css("height", container.height());
            $("<div>").addClass("report-bar-negative").css("width", isNegative ? `max(1px, calc(${widthBar}% - ${padding}px - ${spanWidth}px))` : "0px").css("background-color", negativeColor)
                .appendTo(halfNegativeBar);

            $('<div>').appendTo(container).addClass("report-bar-half-positive").css("height", container.height())
                .css("width", isNegative ? "0px" : `max(1px, calc(${(widthBar / 2)}% - ${padding}px - ${spanWidth}px))`).css("background-color", barColor);

            if (span && hasNegativeValues && isNegative) {
                span.appendTo(halfNegativeBar);
            }
        }
        else {
            $('<div>').appendTo(container).attr("title", options.text).addClass("report-bar").css("background-color", barColor).css("width", `max(1px, calc(${widthBar}% - ${(spanWidth)}px))`).css("height", container.height());
        }

        if (column.visualizationMode.barChartText() !== BarChartTextEnum.None) {
            if (column.visualizationMode.barChartTextPosition() === BarChartTextPositionEnum.Begin) {
                if (hasNegativeValues) {
                    if (isNegative) {
                        span.css("right", `${padding}px`);
                    }
                    else {
                        span.css("left", `calc(50% + ${padding}px)`);
                    }
                }
                else {
                    span.css("left", `${padding}px`);
                }
            }
            else if (column.visualizationMode.barChartTextPosition() === BarChartTextPositionEnum.Center) {
                if (hasNegativeValues) {
                    span.css("left", `calc(${(isNegative ? 50 : 75)}% - ${(span.width() / 2)}px)`);
                }
                else {
                    span.css("left", `calc(50% - ${(span.width() / 2)}px)`);
                }
            }
            else {
                if (hasNegativeValues) {
                    if (isNegative) {
                        span.css("right", `max(1px, calc(${widthBar}% - ${(spanWidth - padding)}px))`);
                    }
                    else {
                        span.css("left", `max(calc(50% + 1px), calc(50% + ${(widthBar / 2)}% - ${(spanWidth)}px))`);
                    }
                }
                else {
                    span.css("left", `max(${padding}px, calc(${widthBar}% - ${(spanWidth - padding)}px))`);
                }
            }
        }
    }

    calculateCustomSummary(options) {
        let self = this;

        if (options.summaryProcess === 'start') {
            if (options.name === "ForSubTotal") {
                options.count = 0;
                return;
            }

            options.valueTop = 0;
            options.valueBottom = 0;
            options.valueGrandTotal = 0;
            options.valueSubTotal = 0;

            options.valueTopComparison = 0;
            options.valueBottomComparison = 0;
            options.valueGrandTotalComparison = 0;

            if (self.result.reportType === ReportTypeEnum.Analysis) {
                options.column = self.result.columns.find(x => x.dataField === options.name);
            }

            if (options.column.groupingType === GroupingTypeEnum.DSUM || options.column.groupingType === GroupingTypeEnum.WDSUM) {
                options.metricValues = [];
                options.column.dependentColumns.forEach((dColumn, index) => {
                    options.metricValues[index] = {
                        topValue: dColumn.groupingType === GroupingTypeEnum.MIN || dColumn.groupingType === GroupingTypeEnum.MAX ? undefined : 0,
                        bottomValue: 0,
                    };
                });
            }
        }

        if (options.summaryProcess === 'calculate') {
            if (options.name === "ForSubTotal") {
                if (!options.totalValue)
                    options.totalValue = options.value[self.result.columns.find(x => x.groupId === options.groupIndex).index];

                options.count++;
            }
            else {
                if (options.column.functionType === FunctionTypeEnum.Rank)
                    return;

                if (options.column.comparisonType === ComparisonTypeEnum.None || options.column.comparisonType === ComparisonTypeEnum.Value) {

                    if (options.column.functionType === FunctionTypeEnum.AccumulatedAll) {
                        options.valueTop = options.value[options.column.indexBase];

                        if (options.column.groupingType === GroupingTypeEnum.WSUM)
                            options.valueBottom = options.value[options.column.indexBottom];

                        return;
                    }

                    if (options.column.functionType === FunctionTypeEnum.PercentOfTotal) {
                        if (options.column.groupingType === GroupingTypeEnum.WSUM)
                            options.valueGrandTotal = options.value[options.column.indexBase + 3];
                        else
                            options.valueGrandTotal = options.value[options.column.indexBase + 1];
                    }

                    if (self.result.reportType === ReportTypeEnum.Analysis && options.column.functionType === FunctionTypeEnum.Accumulated) {
                        options.valueSubTotal = options.value[options.column.groupingType === GroupingTypeEnum.WSUM ? options.column.indexBottom + 2 : options.column.indexBase + 1];
                    }

                    options.valueTop += options.value[options.column.indexBase];

                    //WSUM
                    if (options.column.groupingType === GroupingTypeEnum.WSUM)
                        options.valueBottom += options.value[options.column.indexBottom];

                    //DSUM - WDSUM
                    if (options.column.groupingType === GroupingTypeEnum.DSUM || options.column.groupingType === GroupingTypeEnum.WDSUM) {
                        options.column.dependentColumns.forEach((dColumn, index) => {
                            switch (dColumn.groupingType) {
                                case GroupingTypeEnum.MIN:
                                    if (options.metricValues[index].topValue === undefined) {
                                        options.metricValues[index].topValue = options.value[dColumn.indexBase];
                                    }
                                    else {
                                        options.metricValues[index].topValue = Math.min(options.metricValues[index].topValue, options.value[dColumn.indexBase]);
                                    }
                                    break;
                                case GroupingTypeEnum.MAX:
                                case GroupingTypeEnum.TSUM:
                                    if (options.metricValues[index].topValue === undefined) {
                                        options.metricValues[index].topValue = options.value[dColumn.indexBase];
                                    }
                                    else {
                                        options.metricValues[index].topValue = Math.max(options.metricValues[index].topValue, options.value[dColumn.indexBase]);
                                    }
                                    break;
                                //case 6:
                                //    options.metricValues[index].topValue += 1;
                                //    break;
                                default:
                                    options.metricValues[index].topValue += options.value[dColumn.indexBase];
                                    if (dColumn.groupingType === GroupingTypeEnum.WSUM)
                                        options.metricValues[index].bottomValue += options.value[dColumn.indexBottom];
                                    break;
                            }
                        });
                    }
                }
                else {
                    if (options.column.functionType === FunctionTypeEnum.AccumulatedAll) {
                        options.valueTop = options.value[options.column.indexBase];
                        options.valueTopComparison = options.value[options.column.indexComparison];

                        if (options.column.groupingType === GroupingTypeEnum.WSUM) {
                            options.valueBottom = options.value[options.column.indexBottom];
                            options.valueBottomComparison = options.value[options.column.indexBottomComparison];
                        }

                        return;
                    }

                    options.valueTop += options.value[options.column.indexBase];
                    options.valueTopComparison += options.value[options.column.indexComparison];

                    if (options.column.groupingType === GroupingTypeEnum.WSUM) {
                        options.valueBottom += options.value[options.column.indexBottom];
                        options.valueBottomComparison += options.value[options.column.indexBottomComparison];
                    }

                    if (options.column.functionType === FunctionTypeEnum.PercentOfTotal) {
                        if (options.column.groupingType === GroupingTypeEnum.WSUM) {
                            options.valueGrandTotal = options.value[options.column.indexBase + 3];
                            options.valueGrandTotalComparison = options.value[options.column.indexComparison + 3];
                        }
                        else {
                            options.valueGrandTotal = options.value[options.column.indexBase + 1];
                            options.valueGrandTotalComparison = options.value[options.column.indexComparison + 1];
                        }
                    }
                }
            }
        }

        if (options.summaryProcess === 'finalize') {
            if (options.name === "ForSubTotal") {
                let subTotalText = options.totalValue;
                if (typeof options.totalValue === "object") {
                    subTotalText = options.totalValue.toString();
                }

                if (subTotalText && typeof subTotalText === "string") {
                    options.totalValue = replaceBasicHtmlContent((subTotalText as any), false);
                }

                if (self.itemConfig.subtotalsPosition() === TotalsPositionEnum.Top) {
                    options.totalValue += self.itemConfig.showReportRowCount() ? ` (${options.count})` : "";
                }
                else {
                    options.totalValue = `${self.itemConfig.subTotalText()} ${(options.totalValue !== null ? options.totalValue : "")}${(self.itemConfig.showReportRowCount() ? ` (${options.count})` : "")}`
                }
                return;
            }

            if (options.column.functionType === FunctionTypeEnum.Rank) {
                options.totalValue = 0;
                return;
            }

            if (options.column.comparisonType === ComparisonTypeEnum.None || options.column.comparisonType === ComparisonTypeEnum.Value) {

                options.totalValue = options?.valueTop;

                if (self.result.reportType === ReportTypeEnum.Analysis && options.column.functionType === FunctionTypeEnum.Accumulated) {
                    options.totalValue = options.valueSubTotal;
                    return;
                }

                if (options.column.groupingType === GroupingTypeEnum.WSUM) {
                    if (options.column.functionType === FunctionTypeEnum.PercentOfTotal) {
                        options.totalValue = options.valueBottom === 0 || options.valueGrandTotal === 0 ? 0 : (options.valueTop / options.valueBottom) / options.valueGrandTotal;
                        return;
                    }

                    options.totalValue = options.valueBottom === 0 ? 0 : options.valueTop / options.valueBottom;
                }
                else if (options.column.groupingType === GroupingTypeEnum.DSUM || options.column.groupingType === GroupingTypeEnum.WDSUM) {
                    if (options.column.functionType === FunctionTypeEnum.AccumulatedAll)
                        return;

                    if (options.column.calculateTotals === CalculateTotalsEnum.UseFormula) {
                        options.totalValue = 0;
                        let formula = options.column.formulaTop;

                        options.column.dependentColumns.forEach((dColumn, index) => {
                            let dColumnValue = 0;

                            if (dColumn.groupingType === GroupingTypeEnum.WSUM) {
                                if (options.metricValues[index].bottomValue !== 0)
                                    dColumnValue = options.metricValues[index].topValue / options.metricValues[index].bottomValue;
                            }
                            else {
                                dColumnValue = options.metricValues[index].topValue;
                            }
                            formula = formula.replaceAll(`[${dColumn.indexBase}]`, dColumnValue);
                        });

                        if (options.column.functionType === FunctionTypeEnum.PercentOfTotal) {
                            formula = `IIF(${options.valueGrandTotal} == 0, 0, (${formula}) / ${options.valueGrandTotal})`;
                        }

                        options.totalValue = eval(formula);
                    }
                }
            }
            else {
                if (options.column.groupingType === GroupingTypeEnum.WSUM) {
                    let valueTop = options.valueTop;
                    let valueTopComparison = options.valueTopComparison;
                    let valueBottom = options.valueBottom;
                    let valueBottomComparison = options.valueBottomComparison;

                    let value = valueBottom === 0 ? 0 : valueTop / valueBottom;
                    let valueComparison = valueBottomComparison === 0 ? 0 : valueTopComparison / valueBottomComparison;

                    if (options.column.functionType === FunctionTypeEnum.PercentOfTotal) {
                        value = options.valueGrandTotal === 0 ? 0 : value / options.valueGrandTotal;
                        valueComparison = options.valueGrandTotalComparison === 0 ? 0 : valueComparison / options.valueGrandTotalComparison;
                    }

                    let valueVariation = value - valueComparison;

                    if (options.column.comparisonType === ComparisonTypeEnum.PercentageVariation) {
                        valueVariation = valueComparison === 0 ? 0 : valueVariation / valueComparison;
                    }
                    options.totalValue = valueVariation;
                }
                else {
                    let value = options.valueTop;
                    let valueComparison = options.valueTopComparison;
                    value = value - valueComparison;
                    if (options.column.comparisonType === ComparisonTypeEnum.PercentageVariation) {
                        value = valueComparison === 0 ? 0 : value / valueComparison;
                    }

                    options.totalValue = value;
                }
            }

        }
    };

    reportRowClick(e, element, event) {
        let self = this;

        //e.handled indicates that it treated by another function, ex. to expand a group
        if (e.handled)
            return;

        let widget = this.dashboardWidget;
        let isWidget = this.isDashboardWidget;
        if (event) {
            if (isWidget) {
                if (widget.isSelected)
                    event.stopPropagation();
                else
                    return;
            }
        }

        if (!self.isDrilldownPossible)
            return;

        if (e.rowType === "groupFooter") {
            return;
        }

        let tabValues: Array<FilterValuesVM> = [];

        if (e.rowType === "data") {
            for (let i = 0; i < this.result.columns.length; i++) {
                let column = this.result.columns[i];

                if (!column.isMetric && column.groupingType === GroupingTypeEnum.GROUP_BY && !column.isGrouping) {
                    let value = e.data[column.index];
                    if (value !== null && value !== undefined) {
                        if (typeof value === 'object') {
                            value = value.value;
                        }

                        if (column.dataType === "date") {
                            value = value.slice(0, 10);
                        }
                    }

                    tabValues.push({
                        name: column.queryName,
                        startCondition: value,
                        isGroupField: column.isGrouping,
                    });
                }
                else if (column.isGrouping) {
                    for (var gc = 0; gc < column.groupColumns.length; gc++) {
                        let columnGroup = column.groupColumns[gc];
                        if (!columnGroup.isMetric && columnGroup.groupingType === GroupingTypeEnum.GROUP_BY) {
                            tabValues.push({
                                name: columnGroup.queryName,
                                startCondition: e.data[column.index].values[gc],
                                isGroupField: columnGroup.isGrouping,
                            });
                        }
                    }
                }
            }
        }
        else if (e.rowType === "group") {
            for (let i = 0; i < this.result.columns.length; i++) {
                let column = this.result.columns[i];

                if (column.isGrouping && column.groupIndex <= e.groupIndex) {
                    for (var gc = 0; gc < column.groupColumns.length; gc++) {
                        let columnGroup = column.groupColumns[gc];
                        if (!columnGroup.isMetric && columnGroup.groupingType === GroupingTypeEnum.GROUP_BY) {
                            tabValues.push({
                                name: columnGroup.queryName,
                                startCondition: e.key[column.groupIndex].values[gc],
                                isGroupField: columnGroup.isGrouping,
                            });
                        }
                    }
                }
            }
        }

        self.executeDrilldown(tabValues);
    }

    resizeColumns(ignoreColumn) {
        let self = this;

        let visibleColumns = this.result.grid.getVisibleColumns();
        let gridWidth = this.result.gridContainer.width() - visibleColumns.length - 1;
        let borderWidth = 0;// result.grid.option("showColumnLines") ? 1 : 0;
        this.result.grid.beginUpdate();
        visibleColumns.forEach(function (gridColumnDev) {
            let gridColumn = gridColumnDev as any;
            if (!gridColumn.isGrouping && (!ignoreColumn || gridColumn.queryName != ignoreColumn.queryName)) {
                let gridField = self.itemConfig.fields().find(function (x) { return x.queryName === gridColumn.queryName; });
                if (gridField) {
                    if (self.itemConfig.columnsWidthType() == ColumnsWidthTypeEnum.Automatic) {
                        gridField.width(null);
                        self.result.grid.columnOption(gridColumn.dataField, "width", undefined);
                    }
                    else if (self.itemConfig.columnsWidthType() == ColumnsWidthTypeEnum.Percentage) {
                        gridField.width(($(`#${gridColumn.headerId}`, self.result.gridContainer).outerWidth() + borderWidth) * 100 / gridWidth);
                        self.result.grid.columnOption(gridColumn.dataField, "width", `${gridField.width()}%`);
                    }
                    else if (self.itemConfig.columnsWidthType() == ColumnsWidthTypeEnum.Pixel) {
                        gridField.width($(`#${gridColumn.headerId}`, self.result.gridContainer).outerWidth());
                        self.result.grid.columnOption(gridColumn.dataField, "width", gridField.width());
                    }
                }
            }
        });
        this.result.grid.endUpdate();
    }

    getFormattingScaleColor(formattingScale) {
        let backgroundColor = null;
        let color = null;
        let iconColor = null;
        if (formattingScale !== null) {
            if (formattingScale.backgroundColor) {
                backgroundColor = formattingScale.backgroundColor;
            }

            if (formattingScale.fontColor) {
                color = formattingScale.fontColor;
            }

            if (formattingScale.color) {
                iconColor = formattingScale.color;
            }
        }

        return {
            backgroundColor: backgroundColor,
            color: color,
            iconColor: iconColor
        }
    }

    applyFormattingRuleCell(container, options, rowType) {
        let self = this;

        let isTotal = rowType !== "data";
        let backgroundColor = options.column.backgroundColor;
        let color = options.column.foreColor;

        let formattingRule = self.result.formattingRules.find(function (x) { return x.id === options.column.formattingRuleId; });
        let isColumnFormattingRule = formattingRule != null;
        let value = options.value;
        let isPercent = options.column.format && options.column.format.style === "percent";

        let formattingScale = FormattingRuleService.getFormattingRuleScale(formattingRule, value, isPercent);
        let colors = self.getFormattingScaleColor(formattingScale);
        if (colors.backgroundColor && colors.backgroundColor.toLowerCase() !== "#ffffff") {
            backgroundColor = colors.backgroundColor;
        }
        if (colors.color) {
            color = colors.color;
        }

        let icon = isColumnFormattingRule && formattingScale ? formattingScale.icon : "none";
        if (formattingScale !== null && icon !== "none") {
            let fontSize = self.itemConfig.fontSize() < 15 ? 15 : self.itemConfig.fontSize();
            if (self.result.reportType === ReportTypeEnum.Pivot && (workbook.workbookConfig.isPrinting || workbook.workbookConfig.isExcelPrinting)) {
                fontSize = self.itemConfig.fontSize();
            }

            if (isTotal) {
                $(".dx-datagrid-summary-item", container)
                    .append($(`<i class='bi-${icon}' style='color:${formattingScale.color};margin-left: 2px;font-size: ${fontSize}px;'></i>`));
            }
            else {
                $('<div>')
                    .html(options.text)
                    .append($(`<i class='bi-${icon}' style='color:${formattingScale.color};margin-left: 2px;font-size: ${fontSize}px;'></i>`))
                    .appendTo(container);
            }
        }
        else {
            if (!isTotal) {
                container.html(options.text);
            }
        }

        let applyColors = function (elements, bColor, fColor) {
            elements.forEach(function (cell) {
                let style = cell.attr("style") || "";
                if (style.length > 0 && !style.endsWith(";")) {
                    style += ";";
                }

                if (fColor) {
                    style += `color: ${fColor} !important;`
                }

                if (bColor && bColor.toLowerCase() !== "#ffffff") {
                    style += `background-color: ${bColor};`
                }

                if (isTotal) {
                    let totalCell = $(".dx-datagrid-summary-item", cell);
                    let totalStyle = totalCell.attr("style") || "";
                    if (totalStyle.length > 0 && !totalStyle.endsWith(";")) {
                        totalStyle += ";";
                    }

                    if (bColor && bColor.toLowerCase() !== "#ffffff") {
                        totalStyle += `background-color: ${bColor};`
                    }

                    if (fColor) {
                        totalStyle += `color: ${fColor} !important;`
                    }

                    totalCell.attr("style", totalStyle);
                }

                cell.attr("style", style);
            });
        }

        let cells = [container];

        applyColors(cells, backgroundColor, color);

        return {
            formattingRule: formattingRule,
            formattingScale: formattingScale
        };
    }

    applyFormattingRuleRow(rowType, rowIndex, rowElement, summaryCells) {
        let self = this;

        let backgroundColor = "";
        let color = "";
        let value = undefined;
        let isPercent = undefined;

        let formattingRule = self.result.formattingRules.find(function (x) { return x.config.applyRow; });
        if (!formattingRule) {
            return;
        }

        let column = self.result.columns.find(x => x.formattingRuleId == formattingRule.id)
        if (column?.dataField !== undefined) {
            isPercent = column.format && column.format.style === "percent";
            if (rowType === "data") {
                value = self.result.grid.cellValue(rowIndex, column.dataField);
            }
            else if (rowType === "group" || rowType === "groupFooter") {
                let summary = summaryCells.find(x => x.find(y => y.name === column.dataField));
                if (summary) {
                    value = summary.find(y => y.name === column.dataField).value;
                }
                else {
                    return;
                }
            }
            else {
                value = self.result.grid.getTotalSummaryValue(column.dataField);
            }
        }
        else {
            return;
        }

        let formattingScale = FormattingRuleService.getFormattingRuleScale(formattingRule, value, isPercent);
        let colors = self.getFormattingScaleColor(formattingScale);
        if (colors.backgroundColor && colors.backgroundColor.toLowerCase() !== "#ffffff") {
            backgroundColor = colors.backgroundColor;
        }
        if (colors.color) {
            color = colors.color;
        }

        let applyColors = function (elements, bColor, fColor) {
            elements.forEach(function (cell) {
                let style = cell.attr("style") || "";
                if (style.length > 0 && !style.endsWith(";")) {
                    style += ";";
                }

                if (fColor && !cell.css("color")) {
                    style += `color: ${fColor} !important;`
                }

                if (bColor && bColor.toLowerCase() !== "#ffffff" && !cell.css("background-color")) {
                    style += `background-color: ${bColor};`
                }

                cell.attr("style", style);
            });
        }

        let cells = [rowElement];
        for (let cell of $("td", rowElement)) {
            cells.push($(cell));
            $(cell).addClass("formattingRule-applyRow");
        }

        applyColors(cells, backgroundColor, color);
    }

    addSeachBoxEvent() {
        $(document).off("keydown", this.showSearchBox).on("keydown", this.showSearchBox);
    }

    showSearchBox(e) {
        //114 - F3
        //70 - F
        //if (e.keyCode === 114 || ((e.ctrlKey || e.metaKey) && e.keyCode === 70)) {
        //    e.preventDefault();

        //    let context = irGlobal.getParentContext();
        //    let settings = reportSettingsOld.getSettings(context);
        //    if (settings) {
        //        settings.enableSearchBox(!settings.enableSearchBox());
        //    }
        //}
    }

    setupSettings() {
        this.createSettingItem(this.itemConfig.filterZeros, "filterZeros", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.keepMetricsDrillDown, "keepMetricsDrillDown", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.grandTotalText, "grandTotalText", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.subTotalText, "subTotalText", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.fontSize, "fontSize", UpdateSettingMode.Repaint);
        this.createSettingItem(this.itemConfig.glReport, "glReport", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.enableRowSelection, "enableRowSelection", UpdateSettingMode.Setup);
        this.createSettingItem(this.itemConfig.glReport, "glReport", UpdateSettingMode.Reload);
        //this.createSettingItem(this.itemConfig.isAggregative, "isAggregative", UpdateSettingMode.Reload);

        this.createSettingItem(this.itemConfig.numberFixedColumns, "numberFixedColumns", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.totalsPosition, "totalsPosition", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.subtotalsPosition, "subtotalsPosition", UpdateSettingMode.Reload);
        this.createSettingItem(this.itemConfig.showReportRowCount, "showReportRowCount", UpdateSettingMode.Setup);
        

        if (this.itemConfig.reportType() === ReportTypeEnum.Analysis) {
            this.createSettingItem(this.itemConfig.expandAllRowsPrinting, "expandAllRowsPrinting", UpdateSettingMode.Automatic);
            this.createSettingItem(this.itemConfig.expandAllRows, "expandAllRows", UpdateSettingMode.Custom, (newValue: boolean, widget: ReportWidget, isActiveDrilldown: boolean) => {
                widget.result.grid.option("grouping.autoExpandAll", newValue);
                if (newValue) {
                    widget.result.grid.expandAll();
                }
                else {
                    widget.result.grid.collapseAll();
                }
            });

            this.createSettingItem(this.itemConfig.enableSearchBox, "enableSearchBox", UpdateSettingMode.Custom, (newValue: boolean, widget: ReportWidget, isActiveDrilldown: boolean) => {
                widget.result.grid.option("searchPanel.visible", newValue);

                if (isActiveDrilldown) {
                    let searchBox = $('.dx-datagrid-search-panel.dx-textbox.dx-texteditor.dx-searchbox', widget.result.gridContainer).data('dxTextBox');
                    if (searchBox) {
                        searchBox.focus();
                    }
                }
            });
        }
    }

    repaintForResize() {
        //Grid doesn't paint the column divider lines when resized sometimes
        this.repaint();
    }

    repaint() {
        this.result.grid.repaint();
    }

    runSetup() {
        this.setup();
    }

    private resize(context) {
    //    if (context && context.length > 1) {
    //        return;
    //    }

    //    let grid = null;
    //    const isWidget = this.tabOrWidget.tabOrWidget === TabOrWidgetEnum.Widget;
    //    if (isWidget) {
    //        if (!context.hasClass("widgetContainer") && context.closest(".widgetContainer").length > 0) {
    //            context = context.closest(".widgetContainer");
    //        }
    //    }
    //    const type = this.itemConfig.reportType();

    //    if (type === ReportTypeEnum.Analysis) {
    //        grid = this.result.grid;
    //        if (grid)
    //            grid._$element.css("overflow", "auto");
    //    }
    //    else if (type === ReportTypeEnum.Pivot) {
    //        grid = pivotGrid.getPivotGridInstance(context);
    //        if (grid)
    //            grid._$element.css("overflow", "hidden");
    //    }

    //    if (!grid)
    //        return;

    //    let gridContainer = grid._$element;

    //    if (type === ReportTypeEnum.Analysis || type === ReportTypeEnum.Pivot) {
    //        if (isWidget) {
    //            //gridContainer.height(gridContainer.closest(".widget-result").height());
    //        }
    //        else {
    //            let offSet = gridContainer.offset();
    //            let windowHeight = $(window).height();
    //            //gridContainer.css("overflow", "auto");
    //            ////-40 so we can avoid unecessary vertical scrollbars.
    //            let calculatedHeight = windowHeight - offSet.top - 5;
    //            //if (calculatedHeight > 0) {
    //            //    gridContainer.height(calculatedHeight);
    //            //}
    //        }

    //        grid.repaint();
    //    }
    }

    override print() {
        let href = `/Email/Html?scope=Report&mappingId=${this.tab.workbookConfig.mappingId}&workbookId=${this.tab.workbookConfig.workbookId()}&tabId=${this.tab.workbookConfig.activeTab().id()}&print=True&em=False`;
        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }

        window.open(href, "_blank").focus();
    }

    override exportToPDF(isLandscape: boolean, templateId: number) {
        let href = `/Email/Pdf?scope=Report&mappingId=${workbook.workbookConfig.mappingId}&workbookId=${workbook.workbookConfig.workbookId()}&tabId=${workbook.workbookConfig.activeTab().id()}`;
        if (isLandscape) {
            href += `&landscape=${isLandscape}`;
        }

        if (templateId && templateId > 0) {
            href += `&pdfTemplateId=${templateId}`;
        }

        if (this.isDashboardWidget) {
            href += `&widgetId=${this.dashboardWidget.id()}`;
        }

        window.open(href, "_blank").focus();
    }

    override exportToXLSX(withoutHeaders: boolean) {
        workbook.workbookConfig.workbookHelper.exportToXLSXCSV(false, withoutHeaders, workbook.workbookConfig.activeTabOrWidget().getBaseSubmitObject(), (settings) => {
            printExport.exportReportToExcel(settings, this.result.grid, this.$reportContent);
        });
    }

    override exportToCSV(withoutHeaders: boolean) {
        workbook.workbookConfig.workbookHelper.exportToXLSXCSV(true, withoutHeaders, workbook.workbookConfig.activeTabOrWidget().getBaseSubmitObject(), (settings) => {
            printExport.exportReportToExcel(settings, this.result.grid, this.$reportContent);
        });
    }
}